import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

import { toRefs, ref, watch } from 'vue';
import MessageInputEditor from './message-input-editor.vue';
import MessageInputAt from './message-input-at.vue';
import MessageInputButton from './message-input-button.vue';
import MessageInputReferenceOrReply from './message-input-reference-or-reply.vue';
import { JSONToObject } from '../utils/utils';
import { handleErrorPrompts } from '../../utils';


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  placeholder: {
    type: String,
    default: 'this is placeholder',
  },
  conversation: {
    type: Object,
    default: () => ({}),
  },
  replyOrReference: {
    type: Object,
    default: () => ({}),
  },
  isGroup: {
    type: Boolean,
    default: false,
  },
  memberList: {
    type: Array,
    default: () => [],
  },
  isMute: {
    type: Boolean,
    default: true,
  },
  muteText: {
    type: String,
    default: '',
  },
  enableInput: {
    type: Boolean,
    default: true,
  },
  enableAt: {
    type: Boolean,
    default: true,
  },
  enableDragUpload: {
    type: Boolean,
    default: true,
  },
  enableTyping: {
    type: Boolean,
    default: true,
  },
  env: {
    type: Object,
    default: () => ({}),
  },
},
  emits: ['sendMessage', 'resetReplyOrReference', 'onTyping'],
  setup(__props, { expose: __expose, emit: __emit }) {

const props = __props;

const emit = __emit;
const { placeholder, isGroup, memberList, conversation, replyOrReference, env, enableTyping } = toRefs(props);
const editor = ref();
const isH5 = ref(props?.env?.isH5);

watch(
  () => conversation.value,
  (newVal: any, oldVal: any) => {
    if (newVal?.conversationID !== oldVal?.conversationID) {
      // conversation change
      editor?.value?.resetEditor();
    }
  },
  {
    immediate: true,
  }
);

const sendMessage = async () => {
  const TUIServer = (window as any)?.TUIKitTUICore?.TUIServer?.TUIChat;
  const messageList = editor?.value?.getEditorContent();
  const replyOrReferenceObject = replyOrReference.value;
  await messageList?.forEach(async (content: any) => {
    try {
      let cloudCustomData, res;
      // handle message typing
      cloudCustomData = handleMessageWithTyping(cloudCustomData);
      switch (content?.type) {
        case 'text':
          // 引用和回复只支持文本消息（对标微信）
          // replay or reference message
          cloudCustomData = handleMessageReplyOrReference(cloudCustomData);
          // @ text message
          if (content?.payload?.atUserList) {
            res = await TUIServer?.sendTextAtMessage(
              {
                text: JSON.parse(JSON.stringify(content?.payload?.text)),
                atUserList: content?.payload?.atUserList,
              },
              cloudCustomData
            );
          } else {
            res = await TUIServer?.sendTextMessage(JSON.parse(JSON.stringify(content?.payload?.text)), cloudCustomData);
          }
          if (replyOrReferenceObject?.show === 'reply') {
            await TUIServer.replyMessage(res?.data?.message);
          }
          break;
        case 'image':
          await TUIServer?.sendImageMessage(content?.payload?.file);
          break;
        case 'video':
          await TUIServer?.sendVideoMessage(content?.payload?.file);
          break;
        case 'file':
          await TUIServer?.sendFileMessage(content?.payload?.file);
          break;
        default:
          break;
      }
      emit('sendMessage');
    } catch (error: any) {
      handleErrorPrompts(error, env.value);
    }
  });
  editor?.value?.resetEditor();
  resetReplyOrReference();
};

const onTyping = (inputContentEmpty: boolean, inputBlur: boolean) => {
  emit('onTyping', inputContentEmpty, inputBlur);
};

const handleMessageWithTyping = (cloudCustomData: any) => {
  if (enableTyping.value) {
    if (!cloudCustomData) {
      cloudCustomData = {};
    }
    cloudCustomData.messageFeature = {
      needTyping: 1,
      version: 1,
    };
  }
  return cloudCustomData;
};

const handleMessageReplyOrReference = (cloudCustomData: any) => {
  if (replyOrReference?.value?.show !== 'reply' && replyOrReference?.value?.show !== 'reference') {
    return cloudCustomData;
  }
  if (!cloudCustomData) {
    cloudCustomData = {};
  }
  cloudCustomData.messageReply = {
    messageAbstract: replyOrReference?.value?.content,
    messageSender: replyOrReference?.value?.message?.nick || replyOrReference?.value?.message?.from,
    messageID: replyOrReference?.value?.message?.ID,
    messageType: replyOrReference?.value?.type,
    version: 1,
  };
  if (replyOrReference?.value?.show === 'reply') {
    try {
      cloudCustomData.messageReply.messageRootID = replyOrReference?.value?.message?.ID;
      if (replyOrReference?.value?.message?.cloudCustomData) {
        const replyMessageCloudCustomData = JSONToObject(replyOrReference?.value?.message?.cloudCustomData as any);
        cloudCustomData.messageReply.messageRootID =
          replyMessageCloudCustomData?.messageReply?.messageRootID || replyOrReference?.value?.message?.ID;
      }
    } catch (error) {
      console.warn(error);
    }
  }
  return cloudCustomData;
};

const addEmoji = (emoji: any) => {
  editor?.value?.addEmoji(emoji);
};

const resetReplyOrReference = () => {
  emit('resetReplyOrReference');
};

const reEdit = (content: any) => {
  editor?.value?.resetEditor();
  resetReplyOrReference();
  editor?.value?.setEditorContent(content);
};

__expose({
  addEmoji,
  reEdit,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['message-input', isH5.value && 'message-input-h5'])
  }, [
    _createVNode(MessageInputEditor, {
      ref_key: "editor",
      ref: editor,
      isH5: isH5.value,
      placeholder: _unref(placeholder),
      isGroup: _unref(isGroup),
      isMute: __props.isMute,
      muteText: __props.muteText,
      enableInput: __props.enableInput,
      enableAt: __props.enableAt,
      enableTyping: _unref(enableTyping),
      enableDragUpload: __props.enableDragUpload,
      onSendMessage: sendMessage,
      onOnTyping: onTyping
    }, null, 8, ["isH5", "placeholder", "isGroup", "isMute", "muteText", "enableInput", "enableAt", "enableTyping", "enableDragUpload"]),
    (!__props.isMute)
      ? (_openBlock(), _createBlock(MessageInputButton, {
          key: 0,
          isH5: isH5.value,
          onSendMessage: sendMessage
        }, null, 8, ["isH5"]))
      : _createCommentVNode("", true),
    (__props.enableAt)
      ? (_openBlock(), _createBlock(MessageInputAt, {
          key: 1,
          memberList: _unref(memberList),
          isGroup: _unref(isGroup),
          selfInfo: _unref(conversation)?.groupProfile?.selfInfo,
          isH5: isH5.value
        }, null, 8, ["memberList", "isGroup", "selfInfo", "isH5"]))
      : _createCommentVNode("", true),
    _createVNode(MessageInputReferenceOrReply, {
      replyOrReference: _unref(replyOrReference),
      isH5: isH5.value,
      onResetReplyOrReference: resetReplyOrReference
    }, null, 8, ["replyOrReference", "isH5"])
  ], 2))
}
}

})